export enum CaptchaTypes {
  Turnstile = 'turnstile',
  Recaptcha = 'recaptcha',
}
